/**
 * author: Alex Lai
 * Support Website: https://laialex.com
 * Email: alex@laialex.com
 * Create Time: 2023/11/14
 */
import React, {Component} from "react";
import * as UI from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import apis from "../../../../utils/apis";
import {BellOutlined} from "@ant-design/icons";


const {TextArea} = UI.Input
const {Option} = UI.Select

export default class PortsForwarding extends Component
{
    constructor()
    {
        super();
        this.state = {
            tableData: [],
            paging: {total: 0, pageNumber: 1, pageSize: 20},
            tableLoad: false,
            searchKey: {},
            editShow: false,
            editCurr: {},
            submitting: false,
            clients: []
        }
    }
    componentDidMount()
    {
        this.clientSync()
        this.tableDataSync(1)
    }

    /**
     * 终端加载
     */
    clientSync () {
        var that = this
        let para = {}
        para.pageNumber = 1
        para.pageSize = 2000
        apis.inpClientList(para).then(function (resp) {
            that.setState({
                clients: resp.data.data.data,
            })
        })
    }

    /**
     * 发起搜索
     * @param params
     * @constructor
     */
    makeSearch = (params) => {
        this.setState({
            searchKey: params
        })
        var that = this
        setTimeout(function () {
            that.tableDataSync()
        }, 200)
    }
    /**
     * 签名列表
     * @param pageNumber
     Object.assign(para, that.state.keywords)
     * @param pageSize
     * @constructor
     */
    tableDataSync = (pageNumber = 1) => {
        let that = this;
        let para = {};
        para.pageNumber = pageNumber;
        para.pageSize = 20;
        that.setState({
            tableLoad: true
        })
        Object.assign(para, that.state.searchKey)
        apis.inpTunnelList(para).then(function (resp) {
            that.setState({
                tableLoad: false
            })
            var curr = {
                total: resp.data.data.total,
                pageNumber: pageNumber
            }
            that.setState({
                tableData: resp.data.data.data,
                paging: curr
            })
        })
    }


    render()
    {
        var that = this

        const columns = [
            {
                title: "ID",
                dataIndex: "id"
            },
            {
                title: "备注",
                dataIndex: "remark"
            },
            {
                title: "客户端",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <div style={{color: "indigo"}}>{row.client.remark}({row.client.endpoint.code})</div>
                    )
                }
            },
            {
                title: "转发协议",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <UI.Button type={"dashed"} shape={"round"}>{row.port}</UI.Button>
                    )
                }
            },
            {
                title: "本地资源",
                key: "id",
                render: function (value, row, index) {
                    return row.target
                }
            },
            {
                title: "对外端口",
                key: "id",
                render: function (value, row, index) {
                    return row.port
                }
            },
            {
                title: "访问地址",
                key: "id",
                render: function (value, row, index) {
                    return `${row.client.endpoint.code}.inp.alai.pub:${row.port}`
                }
            },
            {
                title: "可用",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <UI.Button shape={"round"} type={"circle"}>{row.state ? '是' : '否'}</UI.Button>
                    )
                }
            },
            {
                title: "管理",
                key: "id",
                fixed: "right",
                render: function (value, row, index) {
                    return (
                        <span>
                             <UI.Button onClick={() => {
                                 var data = JSON.parse(JSON.stringify(row))
                                 data.client = data.client.id
                                 that.setState({
                                     editCurr: data,
                                     editShow: true
                                 })
                             }} type={"link"}>编辑</UI.Button>
                        </span>
                    )
                }
            }
        ]

        return (
            <div>
                <PageHeader title="端口转发服务" subTitle="端口转发服务" extra={[
                    <UI.Button key="1" type="primary" shape="round" onClick={() => {
                        that.setState({
                            editCurr: {},
                            editShow: true,
                            submitting: false
                        })
                    }}>新增端口转化</UI.Button>
                ]}/>

                <UI.Card>
                    <div style={{marginTop: '22px'}}>
                        <UI.Form onFinish={that.MakeSearch} layout={"inline"}>
                            <UI.Form.Item label={"转发备注"} name={"remark__contains"}>
                                <UI.Input placeholder={"转发备注"}/>
                            </UI.Form.Item>
                            <UI.Form.Item>
                                <UI.Button type={"primary"} htmlType={"submit"}>快速搜索</UI.Button>
                            </UI.Form.Item>
                        </UI.Form>
                    </div>
                </UI.Card>

                <div style={{marginTop: '22px'}}>
                    <UI.Table
                        rowKey="id"
                        dataSource={this.state.tableData}
                        columns={columns}
                        loading={this.state.tableLoad}
                        pagination={{
                            total: this.state.paging.total,
                            defaultPageSize: 20,
                            defaultCurrent: this.state.paging.pageNumber,
                            onChange: this.tableDataSync
                        }}/>
                </div>

                <UI.Modal visible={that.state.editShow} title={'定时任务执行客户端名称'} onCancel={() => {
                    that.setState({
                        editCurr: {},
                        editShow: false,
                        submitting: false
                    })
                }} footer={null} destroyOnClose>
                    <UI.Form onFinish={(params => {
                        that.setState({
                            submitting: true
                        })
                        if (that.state.editCurr.id) {
                            params.id = that.state.editCurr.id
                        }
                        apis.inpTunnelAdmin(params).then(resp => {
                            that.setState({
                                submitting: false
                            })
                            if (resp.data.code === 200 && resp.data.data.code === 200) {
                                UI.message.success("提交信息成功")
                                that.tableDataSync(that.state.editCurr.id ? that.state.paging.pageNumber : 1)
                                that.setState({
                                    submitting: false,
                                    editShow: false,
                                    editCurr: {}
                                })
                            } else {
                                UI.message.error(resp.data.data.msg ? resp.data.data.msg : resp.data.msg)
                            }
                        })
                    })} labelCol={{span: 24}} labelAlign={"left"} initialValues={that.state.editCurr}>
                        <UI.Form.Item label={"转发备注"} name={"remark"}
                                      rules={[{required: true, message: '转发备注'}]}>
                            <UI.Input placeholder={"转发备注"}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"隧道类型"} name={"type"}
                                      rules={[{required: true, message: '隧道类型'}]}>
                            <UI.Radio.Group>
                                <UI.Radio value={"tcp"}>tcp</UI.Radio>
                                <UI.Radio value={"udp"}>udp</UI.Radio>
                                <UI.Radio value={"httpProx"}>httpProx</UI.Radio>
                                <UI.Radio value={"socks5"}>socks5</UI.Radio>
                                <UI.Radio value={"secret"}>secret</UI.Radio>
                                <UI.Radio value={"p2p"}>p2p</UI.Radio>
                            </UI.Radio.Group>
                        </UI.Form.Item>
                        <UI.Form.Item label={"绑定客户端"} name={"client"} rules={[{required: true, message: '绑定客户端'}]}>
                            <UI.Select placeholder={"绑定客户端"} style={{width: "100%"}}>
                                {that.state.clients.map(item => {
                                    return (
                                        <Option value={item.id} key={item.id}>{item.remark}</Option>
                                    )
                                })}
                            </UI.Select>
                        </UI.Form.Item>
                        <UI.Form.Item label={"规则可用"} name={"state"}
                                      rules={[{required: true, message: '规则可用'}]}>
                            <UI.Radio.Group>
                                <UI.Radio value={true}>可用</UI.Radio>
                                <UI.Radio value={false}>禁用</UI.Radio>
                            </UI.Radio.Group>
                        </UI.Form.Item>
                        <UI.Form.Item label={"本地端口"} name={"target"} help={"例如:127.0.0.1:8080"}
                                      rules={[{required: true, message: '本地端口'}]}>
                            <UI.Input placeholder={"本地端口"}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"出口端口"} name={"port"} help={"例如:8080"}
                                      rules={[{required: true, message: '出口端口'}]}>
                            <UI.InputNumber style={{width:"100%"}} min={1000} max={99999} placeholder={"出口端口"}/>
                        </UI.Form.Item>
                        <UI.Form.Item>
                            <UI.Button htmlType={"submit"} loading={that.state.submitting} type={"primary"}
                                       block>提交工作流节点信息
                            </UI.Button>
                        </UI.Form.Item>
                    </UI.Form>
                </UI.Modal>
            </div>
        )
    }
}